import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { LoginFacade } from '../../../domains/app/login.facade';
import { NewUserSignUpInfo } from '../../../domains/app/models/new-user-sign-up-info';


@Component({
  selector: 'gc-signup-form',
  templateUrl: './signup-form.component.html',
  styleUrls: ['./signup-form.component.scss'],
})
export class SignupFormComponent implements OnInit {
  form!: UntypedFormGroup;

  constructor(
    private login: LoginFacade,
    private fb: UntypedFormBuilder,
  ) {
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      // TT-260 item 8: required, because companies need a way to call their
      // connections. Same rule and format as the VTI sign-up.
      phoneNumber: ['', [Validators.required, Validators.pattern(/^[\d\s().+-]{10,20}$/)]],
      agreedToTermsAndPrivacy: [false, [Validators.requiredTrue]],
    });
  }

  signUp(form: any) {
    if (!form.valid) {
      return;
    }

    const formData = { ...form.value };

    const sanitizedFormData: NewUserSignUpInfo = {
      firstName: this.sanitizeInput(formData.firstName),
      lastName: this.sanitizeInput(formData.lastName),
      email: formData.email.toLowerCase(),
      phoneNumber: this.normalizePhoneNumber(formData.phoneNumber) || undefined,
      type: undefined,
    };

    this.login.registerNewUser(sanitizedFormData);
  }

  // Digits only, then +1XXXXXXXXXX for a 10-digit US number, exactly as the VTI
  // sign-up stores it, so the same person is never on file twice.
  normalizePhoneNumber(input: string): string {
    const digits = (input ?? '').replace(/\D/g, '');
    if (digits.length === 10) {
      return `+1${digits}`;
    }
    if (digits.length === 11 && digits.startsWith('1')) {
      return `+${digits}`;
    }
    return digits;
  }

  sanitizeInput(input: string): string {
    return input
      .replace(/['"]/g, '')
      .trim()
      .replace(/\b\w/g, l => l.toUpperCase());
  }

}
